'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from '@tanstack/react-query'
import _ from 'lodash'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { authApi } from '@/api'
import { Alert, Button, Input } from '@/components'
import type { Auth } from '@/types'

const schema = z.object({
  email: z.string().min(1, 'Email is required').email('Invalid email format'),
})

export default function ForgotPassword({ sendEmailBack }: { sendEmailBack: (email: string) => void }) {
  const [isSent, setIsSent] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  })

  const submit = async (data: Auth.ForgotPasswordRequest) => {
    try {
      await authApi.forgotPassword(data)
      setIsSent(true)
      sendEmailBack(data.email)
      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  }

  const { mutate, error, isPending } = useMutation({ mutationFn: submit })
  const onSubmit = (data: Auth.ForgotPasswordRequest) => {
    mutate({ ...data })
  }
  return (
    <form noValidate autoComplete='off' className='space-y-3' onSubmit={handleSubmit(onSubmit)}>
      <div className='mb-2'>
        <span className='text-2xl font-bold'>1</span>. Enter your email to get a reset password code
      </div>
      <Input
        type='text'
        className='text-base py-2'
        placeholder='email'
        {...register('email')}
        data-error={_.get(errors, 'email.message')}
      />
      {error && <Alert variant='error' message={error.message} />}
      {isSent && <Alert variant='success' message='Reset password code has been sent to your email' />}
      <div className='pt-2'>
        <Button type='submit' className='w-full' working={isPending}>
          Request Confirmation Code
        </Button>
      </div>
    </form>
  )
}
